<template>
  <v-badge
    bottom
    color="error"
    :content="amountTransformationsInUse(column)"
    :value="amountTransformationsInUse(column)"
  >
    <v-icon
      @click="$emit('click')"
      style="transition: 0.25s;"
    >
      {{
        isExpanded
        ? 'fas fa-chevron-up'
        : 'fas fa-chevron-down'
      }}
    </v-icon>
  </v-badge>
</template>

<script>
export default {
  name: "TransformationIcon",

  props: {
    column: {
      type: Object,
    },

    isExpanded: {
      type: Boolean,
      default: false,
    }
  },

  methods: {
    amountTransformationsInUse(column) {
      if (!column) return 0;

      if (!Array.isArray(column.transformations)) return 0;

      const activeTransformations = column.transformations.filter(
        (tf) => tf.isChecked === true);

      return activeTransformations.length;
    },
  }
}
</script>